module.exports = __webpack_public_path__ + "img/no_image.437d9150.jpg";